// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"629":"26b53f94","678":"232cfdc8"}[chunkId] + ".chunk.css";
};